"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_perfect_scrollbar_1 = __importDefault(require("react-perfect-scrollbar"));
var Row_1 = __importDefault(require("../Row"));
var Form_1 = __importDefault(require("../Form"));
var MasterContext_1 = __importDefault(require("../../contexts/MasterContext"));
var GridView = function (props) {
    var toolbar = props.toolbar, children = props.children, noform = props.noform, restProps = __rest(props, ["toolbar", "children", "noform"]);
    var _a = react_1.useContext(MasterContext_1.default), selectedItem = _a.selectedItem, handleSubmit = _a.handleSubmit;
    var content = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Row_1.default, null, children),
        react_1.default.createElement(Row_1.default, null, toolbar)));
    return (react_1.default.createElement("div", { className: "ant-app-grid-view-container ant-app-details-content" },
        react_1.default.createElement(react_perfect_scrollbar_1.default, null, noform ? (content) : (react_1.default.createElement(Form_1.default, __assign({ initialValues: selectedItem, onSubmit: handleSubmit }, restProps), content)))));
};
exports.default = GridView;
